import {
	Service, CodeEditorAdapter, CodeEditorOptions, CodeEditor, ContentOptions
} from "@reporting/rp-app-host";
import { File } from "@reporting/rp-types/etl";

const PAGE_SIZE = 500;

export class FileEditorAdapter extends CodeEditorAdapter<CodeEditor> {

	constructor(
		private etlClient: Service,
		private accounting: number,
		private file: File
	) { super() }

	async getContent(opt: ContentOptions) : Promise<string> {
		opt = opt || {offset: 0, limit: PAGE_SIZE};
		return await this.etlClient.get<string>(`files/${this.file.id_file}/content`, {
			offset: opt.offset,
			limit: opt.limit
		});
	}

	getOptions(): CodeEditorOptions {
		return this.createOptions({
			pageSize: PAGE_SIZE,
			readOnly: true,
			history: false,
			language: 'plain/text'
		});
	}

}
